import React, { useState } from "react";
import "./VesselOwnerForm.css";
import axios from "axios";
import Navbar from "../../Navbar/Navbar";
import { Link, useNavigate } from "react-router-dom";
import baseURL from "../../config";

const VesselOwnerForm = () => {
  const [formData, setFormData] = useState({
    company_name: "",
    companyDocument: {
      originalName: "",
      filePath: "",
    },
    company_shortname: "",
    phoneno: "",
    cperson_prefix: "Mr.",
    contactperson: "",
    email: "",
    address: "",
    companyPAN: "",
    companyGST: "",
    country: "India",
    accounts_department1: "Mr.",
    accounts_department11: "",
    phoneaccounts_department1: "",
    accountsEmail: "",
    anotherAccountsTitle: "Mr.",
    anotherAccountsPersonName: "",
    anotherAccountsPhoneNumber: "",
    anotherAccountsEmail: "",
  });

  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    for (const key in formData) {
      if (formData[key]) {
        formDataToSend.append(key, formData[key]);
      } else {
        formDataToSend.append(key, formData[key]);
      }
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${baseURL}/api/vesselOwnerform`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },)

      if (response.status === 200) {
        // console.log("Data saved successfully!");
      } else {
        // console.log("Something went wrong.");
      }
      navigate("/login")
    } catch (err) {
      // console.log(err)
    }

  };

  const countries = [
    "India",
    "United States",
    "Canada",
    "United Kingdom",
    "Australia",
    // Add more countries as needed
  ];



  return (
    <>
      <Navbar />
      <div className="container" style={{ marginTop: "20px" }}>       
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  <h2>Add Company Details</h2>
</div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="company_name">Company Name</label>
            <input
              type="text"
              id="company_name"
              name="company_name"
              value={formData.company_name}
              onChange={handleInputChange}
              
            />
          </div>
          <div className="form-group">
            <label htmlFor="companyDocument">Company Document Upload</label>
            <input
              type="file"
              id="companyDocument"
              name="companyDocument"
              onChange={handleFileChange}
              
            />
          </div>
          <div className="form-group">
            <label htmlFor="company_shortname">Company Short Name</label>
            <input
              type="text"
              id="company_shortname"
              name="company_shortname"
              value={formData.company_shortname}
              onChange={handleInputChange}
              
            />
          </div>
          <div className="form-group">
            <label htmlFor="phoneno">Phone Number</label>
            <input
              type="tel"
              id="phoneno"
              name="phoneno"
              value={formData.phoneno}
              onChange={handleInputChange}
              
            />
          </div>
          <div className="form-group">
            <label>Contact Person Name</label>
            <div className="flex-row">
              <select
                name="cperson_prefix"
                value={formData.cperson_prefix}
                onChange={handleInputChange}
              >
                <option value="MR.">MR.</option>
                <option value="MRS.">MRS.</option>
                <option value="MISS">MISS</option>
              </select>
              <input
                type="text"
                name="contactperson"
                value={formData.contactperson}
                onChange={handleInputChange}
                placeholder="Enter name"
                
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email ID</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              
            />
          </div>
          <div className="form-group">
            <label htmlFor="address">Address</label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              rows="3"
              
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="companyPAN">Company PAN</label>
            <input
              type="text"
              id="companyPAN"
              name="companyPAN"
              value={formData.companyPAN}
              onChange={handleInputChange}
              
            />
          </div>
          <div className="form-group">
            <label htmlFor="companyGST">Company GST</label>
            <input
              type="text"
              id="companyGST"
              name="companyGST"
              value={formData.companyGST}
              onChange={handleInputChange}
              
            />
          </div>
          <div className="form-group">
            <label htmlFor="country">Country</label>
            <select
              id="country"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
            >
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </div>


          <h2>Name of Accounting Team Personnel</h2>
          {/* Name of Person in Accounts Department */}
          <div className="form-group">
            <label>Name of Person in Accounts Department</label>
            <div className="flex-row">
              <select
                name="accounts_department1"
                value={formData.accounts_department1}
                onChange={handleInputChange}
              >
                <option value="MR.">MR.</option>
                <option value="MRS.">MRS.</option>
                <option value="MISS">MISS</option>
              </select>
              <input
                type="text"
                name="accounts_department11"
                value={formData.accounts_department11}
                onChange={handleInputChange}
                placeholder="Enter name"
                
              />
            </div>
          </div>

          {/* Phone Number/Email of Accounts Department */}
          <div className="form-group">
            <label>Phone Number/Email of Accounts Department</label>
            <div className="flex-row">
              <input
                type="tel"
                name="phoneaccounts_department1"
                value={formData.phoneaccounts_department1}
                onChange={handleInputChange}
                placeholder="Phone Number"
                
              />
              <input
                type="email"
                name="accountsEmail"
                value={formData.accountsEmail}
                onChange={handleInputChange}
                placeholder="Email"
                
              />
            </div>
          </div>
          {/* Name of Another Person in Accounts Department */}
          <div className="form-group">
            <label>Name of Another Person in Accounts Department</label>
            <div className="flex-row">
              <select
                name="anotherAccountsTitle"
                value={formData.anotherAccountsTitle}
                onChange={handleInputChange}
              >
                <option value="MR.">MR.</option>
                <option value="MRS.">MRS.</option>
                <option value="MISS">MISS</option>
              </select>
              <input
                type="text"
                name="anotherAccountsPersonName"
                value={formData.anotherAccountsPersonName}
                onChange={handleInputChange}
                placeholder="Enter name"
                
              />
            </div>
          </div>

          {/* Phone Number/Email of Another Accounts Department */}
          <div className="form-group">
            <label>Phone Number/Email of Another Accounts Department</label>
            <div className="flex-row">
              <input
                type="tel"
                name="anotherAccountsPhoneNumber"
                value={formData.anotherAccountsPhoneNumber}
                onChange={handleInputChange}
                placeholder="Phone Number"
                
              />
              <input
                type="email"
                name="anotherAccountsEmail"
                value={formData.anotherAccountsEmail}
                onChange={handleInputChange}
                placeholder="Email"
                
              />
            </div>
          </div>

          <button type="submit" className="vesselformbtn">
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default VesselOwnerForm;
